import POPUP_MENU_STYLE from "../../../../../../src/js/misc/popupMenuStyle";

const cdnUrl = 'https://cdn.utah.gov/utah-header';
const helloWorldFunc = 'function() { alert(\'Hello World!\') }';
const exampleSVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 97.3 60">
<defs><style>.cls-1{fill:#007eff;}</style></defs>
<title>logo-example</title>
<g id="Layer_2" data-name="Layer 2">
<g id="Layer_1-2" data-name="Layer 1">
<path class="cls-1" d="M35,30.35,47.5,8.7h3.62A30,30,0,1,0,50.39,52H47.5Z"/>
<path class="cls-1" d="M72.7,30.35,78.85,19.7h0L72.5,8.7H51.12A30,30,0,0,1,50.39,52H72.5l6.35-11h0Z"/>
<polygon class="cls-1" points="97.3 30.35 91.15 19.7 78.85 19.7 85 30.35 78.85 41 91.15 41 97.3 30.35"/>
</g></g></svg>`;
const helloWorldDiv = '<div>Hello World!</div>';


export default {
	appGrid: {
		helpText: 'Configuration for the grid icon (9 dots) in the header.',
		exampleValue: null,
	}
	,
	appGridIconTitle: {
		helpText: 'Title of the icon action item.',
		exampleValue: 'App Grid',
	}
	,
	appGridIconShowTitle: {
		helpText: 'Determines if the title should be shown. Titles are typically hidden on all header sizes except Large.',
		exampleValue: true,
	}
	,
	appGridIconOnHover: {
		helpText: 'Function to call when the icon is hovered.',
		exampleValue: helloWorldFunc,
	},
	appGridIconPopupContent: {
		helpText: 'DOM content to render in to the icon popup when the icon is hovered. See utahHeader.renderDOM() for how DOM is rendered.',
		exampleValue: '<div>You have triggered this popup</div>',
	},
	appGridIconOnClick: {
		helpText: 'Function to call when the icon is clicked.',
		exampleValue: helloWorldFunc,
	},

	customIdAuthCallback: {
		helpText: 'A function that is triggered when the users authentication changes.',
		exampleValue: 'function (data) { if (data.authenticated) { alert(\'User is authenticated\'); } else { alert(\'User is not authenticated\'); } }',
	},
	customIdCustomParams: {
		helpText: 'An array of custom parameters to use for the UtahID api.',
		exampleValue: 'param1=three param2=four param5=six',
	},
	customIdCustomUrl: {
		helpText: 'A custom url for the UtahID web service api.',
		exampleValue: 'https://wherever.your.auth.lives',
	},
	customIdEnvironment: {
		helpText: 'Environment from the ENVIRONMENT enum: none, a1 (Prod), a2 (AT), a3 (Dev), custom',
		exampleValue: 'a1',
	},
	customIdOnUserClickedSignIn: {
		helpText: 'A function that is triggered when the user clicks to sign in. It is up to you to handle login/logout and you need to tell the header if the user is logged in or logged out.',
		exampleValue: 'function () {window.utahHeader.showUserAsSignedIn({first: \'Put user name here\'});}',
	},
	customIdOnUserClickedSignOut: {
		helpText: 'A function that is triggered when the user clicks to sign out. It is up to you to handle login/logout and you need to tell the header if the user, is logged in or logged out.',
		exampleValue: 'function () {window.utahHeader.showSignIn();}',
	},
	customIdProfileUrl: {
		helpText: 'The URL of the user\'s UtahID profile. This must be supplied for a profile menu item to be generated.',
		exampleValue: 'http://id.utah.gov',
	},
	customIdType: {
		helpText: 'Configuration for the UtahId Sign In / Sign Out action callbacks.',
		exampleValue: null,
	},

	gear: {
		helpText: 'Configuration for the gear icon in the header',
		exampleValue: null,
	},
	gearIconTitle: {
		helpText: 'Title of the icon action item.',
		exampleValue: 'Gear',
	},
	gearIconShowTitle: {
		helpText: 'Determines if the title should be shown. Titles are typically hidden on all header sizes except Large.',
		exampleValue: true,
	},
	gearIconOnHover: {
		helpText: 'Function to call when the icon is hovered.',
		exampleValue: helloWorldFunc,
	},
	gearIconPopupContent: {
		helpText: 'DOM content to render in to the icon popup when the icon is hovered. See utahHeader.renderDOM() for how DOM is rendered.',
		exampleValue: '<div>You have triggered this popup</div>',
	},
	gearIconOnClick: {
		helpText: 'Function to call when the icon is clicked.',
		exampleValue: helloWorldFunc,
	},
	gearIcon: {
		helpText: 'Function to call when the icon is clicked.',
		exampleValue: helloWorldFunc,
	},

	headerLogo: {
		helpText: 'The logo to show in the header. SVG images are preferred, which provide superior image quality at all screen sizes and densities.',
		exampleValue: null,
	},
	headerLogoAltText: {
		helpText: 'Alt text that will be placed in an aria-label attribute of the logo wrapper for accessibility. If a header title is provided the logo will be hidden from screen readers, therefore the title should describe the logo.',
		exampleValue: 'Utah.Gov Application',
	},
	headerLogoDom: {
		helpText: 'This value will be interpreted directly as DOM elements.',
		exampleValue: exampleSVG,
	},
	headerLogoFunction: {
		helpText: 'This function will be called to determine the DOM to show.',
		exampleValue: 'function () { const e = document.createElement(\'img\'); e.src = \'https://cdn.utah.gov/utah-header/latest/examples/img/agency-logo.png\'; return e; }',
	},
	headerLogoString: {
		helpText: 'The DOM will be created using Utah Header\'s renderDOM(). The string should represent well-formed HTML DOM elements.',
		exampleValue: exampleSVG,
	},
	headerLogoUrl: {
		helpText: 'URL to an image to show.',
		exampleValue: 'https://cdn.utah.gov/utah-header/latest/examples/img/agency-logo.png',
	},

	headerShortTitle: {
		helpText: 'A shorter title to show on mobile screens (450px width). It should be no longer than ~20 characters. This value is hidden from screen readers.',
		exampleValue: 'Utah.Gov App',
	},
	headerSize: {
		helpText: 'Determines height of header.',
		exampleValue: null,
	},
	headerStyle: {
		helpText: 'Determines theming color of header.',
		exampleValue: null,
	},
	headerTitle: {
		helpText: 'The title text for the header. You can wrap long titles with \\n such as: My Long Title \\n Goes Here. You can only apply wrapping in the script source. (It doesn\'t work here in this tool)',
		exampleValue: 'Utah.Gov Application',
	},
	headerTitleOnClick: {
		helpText: 'An onClick callback function for when the Title / Logo is clicked. The callback function is passed the click event. Having an onClick callback overrides the click of a configured Header Title URL.',
		exampleValue: helloWorldFunc,
	},
	headerTitleUrl: {
		helpText: 'A URL to be used for an <a> tag containing the Title / Logo.',
		exampleValue: cdnUrl,
	},

	menu: {
		helpText: 'Configuration type for a menu item.',
		exampleValue: null,
	},
	menuDom: {
		helpText: 'This value will be interpreted directly as DOM elements.',
		exampleValue: helloWorldDiv,
	},
	menuFunction: {
		helpText: 'This function will be called to determine the DOM to show. You must return HTML DOM elements from the function.',
		exampleValue: 'function () { const e = document.createElement(\'div\'); e.innerHTML = \'Hello World!\'; return e; }',
	},
	menuOnClick: {
		helpText: 'Function to call when this menu item is clicked. Having a function will override having a url.',
		exampleValue: helloWorldFunc,
	},
	menuOpen: {
		helpText: 'Renders the menu item as "open", showing its children, if it has children.',
		exampleValue: true,
	},
	menuOpenInNewTab: {
		helpText: 'Adds target="_blank" to the "a" tag to have this link open in a new tab.',
		exampleValue: true,
	},
	menuSelected: {
		helpText: 'Render this menu item as "selected" with an arrow.',
		exampleValue: true,
	},
	menuString: {
		helpText: 'Header will convert the given string in to DOM elements using the utahHeader.renderDOM() function. This allows any DOM to be entered initially as a string.',
		exampleValue: helloWorldDiv,
	},
	menuStyle: {
		helpText: 'There are several styles for rending a menu that effect how the menu items are laid out. The configuration is the same for the menu, only the style needs be changed.',
		exampleValue: POPUP_MENU_STYLE.CARD,
	},
	menuText: {
		helpText: 'The text to show in the title of the menu item.',
		exampleValue: 'Menu of Options',
	},
	menuUrl: {
		helpText: 'URL for the menu href where the user goes after the menu item is clicked.',
		exampleValue: cdnUrl,
	},
	menuAltText: {
		helpText: 'Alt Text for this menu item icon.',
		exampleValue: 'Menu Item Icon',
	},

	modifierClasses: {
		helpText: 'CSS modifier classes. Sticky means that the header will stay at the top when scrolling the page. No Shadow means that there is no darker line under the header separating the header from the page.',
		exampleValue: null,
	},

	onHeaderResize: {
		helpText: 'This event fires when the header\'s height changes because of a window resize. This event is debounced. This usually happens when the size of the page is narrowed causing the header to decrease its height. Large and Medium-Large headers will appear as Medium.',
		exampleValue: 'function() { alert(\'Header has resized!\') }',
	},

	question: {
		helpText: 'Configuration for the question icon in the header',
		exampleValue: null,
	},
	questionIconTitle: {
		helpText: 'Title of the icon action item.',
		exampleValue: 'Questions',
	},
	questionIconShowTitle: {
		helpText: 'Determines if the title should be shown. Titles are typically hidden on all header sizes except Large.',
		exampleValue: true,
	},
	questionIconOnHover: {
		helpText: 'Function to call when the icon is hovered.',
		exampleValue: helloWorldFunc,
	},
	questionIconPopupContent: {
		helpText: 'DOM content to render in to the icon popup when the icon is hovered. See utahHeader.renderDOM() for how DOM is rendered.',
		exampleValue: helloWorldDiv,
	},
	questionIconOnClick: {
		helpText: 'Function to call when the icon is clicked.',
		exampleValue: helloWorldFunc,
	},

	searchCallback: {
		helpText: 'When the search dialog is opened and the user searches , this is the callback function that will trigger with the user\'s search query as a parameter.',
		exampleValue: 'function (searchQuery) { alert(\'You searched for "\' + searchQuery + \'"\') }',
	},
	searchIconType: {
		helpText: 'Configuration for the Search icon.',
		exampleValue: null,
	},
	searchOnClick: {
		helpText: 'Function to call when the search icon is clicked.',
		exampleValue: 'function () {const searchQuery = prompt(\'For what do you wish to search?\'); alert(\'You searched for "\' + searchQuery + \'"\')}',
	},
	searchPlaceholder: {
		helpText: 'The placeholder text in the search field.',
		exampleValue: 'Enter your search criteria',
	},
	searchShowTitle: {
		helpText: 'Determines if the title should be shown. Titles are typically hidden on all header sizes except Large.',
		exampleValue: true,
	},
	searchTitle: {
		helpText: 'The title of the action item.',
		exampleValue: 'Search...',
	},
};
